 export  class Roles {
    public static Admin = "ADMIN";
    public static Student = "STUDENT";
    public static Instructor = "INSTRUCTOR";
    public static Examiner = "EXAMINER";
}